// Canonical list of Costco partner warehouse pages, used for internal linking between
// them (a related-cluster signal that helps Google index the set). Every entry points
// at an EXISTING /costco/* URL — nothing here creates, changes, or redirects a URL.
export const COSTCO_WAREHOUSES = [
  { path: '/costco/auburn', name: 'Auburn', suburb: 'Lidcombe', state: 'NSW' },
  { path: '/costco/casula', name: 'Crossroads', suburb: 'Casula', state: 'NSW' },
  { path: '/costco/marsden-park', name: 'Marsden Park', suburb: 'Marsden Park', state: 'NSW' },
  { path: '/costco/lake-macquarie', name: 'Lake Macquarie', suburb: 'Boolaroo', state: 'NSW' },
  { path: '/costco/ardeer', name: 'Ardeer', suburb: 'Ardeer', state: 'VIC' },
  { path: '/costco/epping', name: 'Epping', suburb: 'Epping', state: 'VIC' },
  { path: '/costco/ringwood', name: 'Ringwood', suburb: 'Ringwood', state: 'VIC' },
  { path: '/costco/moorabbin', name: 'Moorabbin Airport', suburb: 'Moorabbin', state: 'VIC' },
  { path: '/costco/north-lakes', name: 'North Lakes', suburb: 'North Lakes', state: 'QLD' },
  { path: '/costco/ipswich', name: 'Ipswich', suburb: 'Bundamba', state: 'QLD' },
  { path: '/costco/gold-coast', name: 'Gold Coast', suburb: 'Coomera', state: 'QLD' },
  { path: '/costco/perth', name: 'Perth Airport', suburb: 'Perth Airport', state: 'WA' },
  { path: '/costco/casuarina', name: 'Casuarina', suburb: 'Casuarina', state: 'WA' },
  { path: '/costco/canberra', name: 'Canberra Airport', suburb: 'Majura Park', state: 'ACT' },
  { path: '/costco/adelaide', name: 'Adelaide', suburb: 'Kilburn', state: 'SA' },
];
